import { Button } from "../../../components/button";
import {
  useLocaleProvider,
  useTranslate,
} from "../../../context/locale-provider";
import styles from "../styles";
import localStyles from "./styles";

const SuccessView = () => {
  const translate = useTranslate(useLocaleProvider());
  return (
    <div className={`${styles.card} ${localStyles.container}`}>
      <h1 className="app_barnsley2">
        {translate("premier_cancel_contracts_form_confirmation_title")}
      </h1>
      <p className="app_leavesden2">
        {translate("premier_cancel_contracts_form_confirmation_description")}
      </p>
      <Button asChild className="app_button">
        <a href={window.location.origin}>
          {translate(
            "premier_cancel_contracts_form_confirmation_cta_continue_shopping"
          )}
        </a>
      </Button>
    </div>
  );
};

export default SuccessView;
